import React, { Component, Fragment } from "react"
import { connect } from "react-redux"
import { Div, H2 } from "@driftt/tide-core"
import { Icon } from '@driftt/tide-icons'
import { equals, isEmpty } from "ramda"

import { OPERATOR_COMPONENTS } from "components/ContactFilterBuilder/constants/OperatorComponents"
import {
  OPERATORS
} from "components/ContactFilterBuilder/constants/Operators"
import { PROPERTY_TYPES } from "components/ContactFilterBuilder/constants/Properties"

import OperatorLabel, { DROPDOWN_VALUE } from "./OperatorLabel"

const mapStateToProps = state => ({
  playbook: state.__CRM.filterBuilder.playbook
})

class OperatorAndValue extends Component {
  constructor(props) {
    super(props)

    const { currentFilter, selectedProp } = props

    let activeOperator
    let value
    let isMostRecent

    const defaultActiveOperator = currentFilter && currentFilter.operator
    const defaultValue = currentFilter && currentFilter.segmentValue.value

    const availableOperators = PROPERTY_TYPES[selectedProp.type].operators
    const defaultActiveOperatorIsValid =
      defaultActiveOperator &&
      availableOperators.includes(defaultActiveOperator)

    if (defaultActiveOperatorIsValid) {
      activeOperator = defaultActiveOperator || OPERATORS.IS_PRESENT
      if (
        [OPERATORS.IS_ANY, OPERATORS.IS_NOT_ANY].includes(defaultActiveOperator)
      ) {
        value = defaultValue ? defaultValue.join("\r\n") : ""
      } else {
        value = defaultValue
      }
    } else {
      activeOperator = OPERATORS.IS_PRESENT
      value = null
      isMostRecent = DROPDOWN_VALUE.FIRST
    }

    this.state = {
      activeOperator,
      value,
      isMostRecent
    }
  }

  updateActiveOperator = event => {
    const { onSelectOp, selectedProp, currentFilter } = this.props
    const nextOperator = event.target.value

    const currentEntityType = currentFilter.segmentProperty.subEntityType

    const isAbsoluteDateOperator = (nextOperator === "IS_BEFORE" && currentEntityType === 'events')||
                           (nextOperator === "IS_AFTER" && currentEntityType === 'events')

    const segmentValue = isAbsoluteDateOperator ?
                         {value: new Date().getTime(), checkForMostRecent: DROPDOWN_VALUE.FIRST} : null


    this.setState({
      activeOperator: nextOperator,
      value: segmentValue,
      isMostRecent: DROPDOWN_VALUE.FIRST
    })

    onSelectOp(nextOperator, segmentValue, selectedProp.type)
  }

  updateActiveOperatorValue = (value, operatorOverride) => {
    const { onSelectOp, selectedProp, currentFilter } = this.props
    const { activeOperator } = this.state

    const currentEntityType = currentFilter.segmentProperty.subEntityType

    const isAbsoluteDateOperator = (activeOperator === "IS_BEFORE" && currentEntityType === 'events') ||
                           (activeOperator === "IS_AFTER" && currentEntityType === 'events')
    const isRelativeDateOperator = (activeOperator === "IS_BEFORE_RELATIVE" && currentEntityType === 'events')||
                           (activeOperator === "IS_AFTER_RELATIVE" && currentEntityType === 'events')

    const segmentValue =  isAbsoluteDateOperator ? {...this.state.value, value: value} : value


    if(isRelativeDateOperator)  {
      Object.assign(value, { checkForMostRecent: this.state.isMostRecent });
    }

    this.setState(
      {
        value: segmentValue
      },
      () => {
        const operator = operatorOverride || activeOperator
        onSelectOp(operator, this.state.value, selectedProp.type)
      }
    )
  }

  setValue = checkForMostRecent => {
    const { onSelectOp, selectedProp } = this.props
    const { activeOperator } = this.state

    this.setState(prevState => ({
      value: {
        ...prevState.value,
        checkForMostRecent: checkForMostRecent
      },
      isMostRecent: checkForMostRecent
    }),
    () => onSelectOp(activeOperator, this.state.value, selectedProp.type))
  }

  renderOperatorSelects = () => {
    const { activeOperator, value } = this.state
    const { currentFilter, selectedProp } = this.props

    const availableOperators =
      PROPERTY_TYPES[selectedProp.type ? selectedProp.type : "EVENT"].operators
    const OperatorComponent = OPERATOR_COMPONENTS[activeOperator]

    const currentEntityType = currentFilter.segmentProperty.subEntityType

    return (
      <Fragment>
        {availableOperators.map(operator => {
          return (
            <Div key={operator} className="filter-builder--operator-select">
              <OperatorLabel
                operator={operator}
                activeOperator={activeOperator}
                updateActiveOperator={this.updateActiveOperator}
                currentEntityType={currentEntityType}
                setValue={this.setValue}
              />
              {equals(operator, activeOperator) && (
                <Div className="filter-builder--operator-value">
                  <OperatorComponent
                    operator={operator}
                    property={selectedProp}
                    onChange={this.updateActiveOperatorValue}
                    value={value}
                  />
                </Div>
              )}
            </Div>
          )
        })}
      </Fragment>
    )
  }

  render() {
    const { onBackNavigation, selectedProp } = this.props
    return (
      <Div className="contact-properties--container filter-builder-view-container">
        <Div
          className="filter-builder--back-button operator-and-select"
          onClick={() => onBackNavigation(false)}
        >
          <Icon name="arrow-1-left" height={10} />
          Back
        </Div>
        <H2 className="filter-builder--operators-title">
          {selectedProp.type === "PLAYBOOK"
            ? selectedProp.label
            : selectedProp.displayName}
        </H2>
        <Div className="filter-builder--operators">
          {!isEmpty(selectedProp) && this.renderOperatorSelects()}
        </Div>
      </Div>
    )
  }
}

export default connect(mapStateToProps)(OperatorAndValue)
